const UserRoleFormData = {
  UserEmail: {
    value: "",
    type: "string",
    required: true
  },
  UserRoleCode: {
    value: "",
    type: "string",
    required: true,
    description:"",
    userRoleMappingId:""
  }
};

const UserRoleFormErrorData = {
  UserEmail: null,
  UserRoleCode: null
};

const setUserRoleFormFieldContent = (
formData,
onFieldValueChange,
onUserAccessCodeChange,
formError,
EditUserEmail,
formStateData,
setFormStateData,
t
) => {
try {
  return [
  [
    {
      fieldtype: "textfield",
      id: "UserEmail",
      type: "text",
      isMandatory: formData.UserEmail.required,
      isDisabled: !!EditUserEmail,
      label: t("userRoleList.userEmail"),
      placeholder: t("userRoleList.userEmail"),
      onChange: onFieldValueChange,
      value: formData.UserEmail.value,
      error: formError.UserEmail,
      byPassRoleCheck:true
    },
    {
      fieldtype: "transfer",
      id: "UserRoleCode",
      type: "text",
      isMandatory: formData.UserRoleCode.required,
      label: t("createUserRole.assignRoles"),
      placeholder: t("createUserRole.assignRoles"),
      onChange: onUserAccessCodeChange,
      error: formError.UserRoleCode,
      userEmail: formData.UserEmail.value,
      formStateData:formStateData,
      setFormStateData:setFormStateData
    }
  ],
];
} catch (err) {
alert(err);
}
};

export { UserRoleFormData, UserRoleFormErrorData,setUserRoleFormFieldContent };
